module.exports = __webpack_public_path__ + "assets/img/monitoring.9bc9bc12.png";